import {
  PaymentMethodRef,
  PaymentMethodType
} from "@wingspanhq/wingspan-api-sdk";
import { MethodValue } from "../../modules/Settings/components/ManageMethods/types";

/**
 * Maps a v3 `PaymentMethodRef` to the method the app renders and manages by.
 *
 * `PAYMENT_CARD` maps to `PaymentCard`, not `CreditCard`: a v3 ref carries a
 * Footprint card id, while v1's `FundingSourceType.PaymentCard` carried a
 * Stripe `pm_…` id off the retired client profile — different entities, so the
 * v1 twin `selectorFundingSourceMethodType` maps the same name differently.
 *
 * Returns `undefined` for a missing ref or an unrenderable type, so callers
 * fall back to an empty state instead of rendering the wrong method.
 */
export const selectorMethodValueFromPaymentMethodRef = (
  paymentMethodRef?: PaymentMethodRef
): MethodValue | undefined => {
  if (!paymentMethodRef) {
    return undefined;
  }

  switch (paymentMethodRef.type) {
    case PaymentMethodType.EXTERNAL_BANK_ACCOUNT:
      return { id: paymentMethodRef.id, type: "Account" };

    case PaymentMethodType.INTERNAL_ACCOUNT:
      return { id: paymentMethodRef.id, type: "InternalAccount" };

    case PaymentMethodType.PAYMENT_CARD:
      return { id: paymentMethodRef.id, type: "PaymentCard" };

    default:
      return undefined;
  }
};
